import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-0"
}
const _hoisted_2 = { class: "introBanner__top" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "introBanner__slogan font-sweetly" }
const _hoisted_5 = {
  key: 0,
  class: "introBanner__body"
}
const _hoisted_6 = {
  key: 0,
  class: "introBanner__bottom"
}
const _hoisted_7 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.title)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", {
          class: "introBanner",
          style: _normalizeStyle([
        _ctx.backgroundImage
          ? { 'background-image': 'url(' + _ctx.backgroundImage + ')' }
          : null,
      ])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
              (_ctx.$slots.body)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _renderSlot(_ctx.$slots, "body")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.$slots.footer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "footer")
                ])
              ]))
            : _createCommentVNode("", true)
        ], 4)
      ]))
    : _createCommentVNode("", true)
}